import { type PersonGeneral, personGeneralSchema } from '@quromedical/models';
import { CrudForm } from 'components/form';
import { personGeneralFields } from 'core/forms';
import type { FormikErrors } from 'formik';
import type React from 'react';
import { useEffect, useState } from 'react';
import { strings } from 'strings';

// TODO: where to organizes this files

type HandleChange = (
  data: Partial<PersonGeneral>,
  errors: FormikErrors<Partial<PersonGeneral>>,
) => void;

interface GeneralFormProps {
  onChange: HandleChange;
  showErrors: boolean;
  initial: Partial<PersonGeneral>;
}

export const GeneralForm: React.FC<GeneralFormProps> = ({
  onChange,
  showErrors,
  initial,
}) => {
  const [initialState, setInitialState] =
    useState<Partial<PersonGeneral>>(initial);

  useEffect(() => {
    setInitialState(() => initialState);
  }, [initialState]);

  return (
    <CrudForm
      key={initialState.identifierValue}
      title={strings.FormLabelPatientDetails}
      fields={personGeneralFields}
      showSubmitButton={false}
      initialValues={initialState}
      includeIcons={true}
      validationSchema={personGeneralSchema}
      onChange={onChange}
      showErrors={showErrors}
      validateOnMount
      onChangeDebounceTime={0}
    />
  );
};
